// ----------------------------------------------------------------------
// <copyright file="Izenda.DataRefreshSetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataRefreshSetting Component
 */
!(function() {
  var React = require('react');
  var Validator = require('share/components/hoc/Izenda.Validator');
  var Input = require('share/components/controls/Izenda.Input');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');

  var ValidatorInput = Validator()(Input);
  var EventsUtils = require('EventUtils');
  var Constants = require('logic/data/Izenda.DataRefreshSettingConstants');
  var localizer = require('share/localization/Izenda.Localizer');
  var { clone } = require('lodash/fp');

  var GRID_SIZE_LABEL = 3;
  var GRID_SIZE_CONTROL = 9;

  var DataRefreshSetting = React.createClass({
    getInitialState: function() {
      return {
        enable: false,
        updateInterval: 0
      };
    },

    componentWillMount: function() {
      var data = this.props.value;
      this.setState({
        enable: data.enable,
        updateInterval: data.updateInterval
      });
    },

    // Handle "data auto refreshed" checkbox change
    onChangeAutoRefreshed: function(enable) {
      this.setState({
        enable: enable
      });
    },

    // Handle "Update interval textbox" change
    onChangeUpdateInterval: function(interval) {
      this.setState({
        updateInterval: parseInt(interval, 10)
      });
    },

    // Return data for update data.
    getValue: function() {
      var dataRefreshSetting = clone(this.state);
      if (!dataRefreshSetting.updateInterval) {
        dataRefreshSetting.updateInterval = 0;
      }
      return dataRefreshSetting;
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;
      var updateIntervalValue;
      if (this.state.updateInterval) updateIntervalValue = this.state.updateInterval;

      var latestRecordValue;
      var intervalConstraint = this.state.enable ? Constants.NUMBER_CONSTRAINT.UPDATE_INTERVAL : {};

      return (
        <div className="izenda-DataRefreshSetting">
          <GridLayout className="form-horizontal">
            <GridLayout.Row className="form-group">
              <GridLayout.Col cols={GRID_SIZE_LABEL}>
                {localizer.getText('REPORTDESIGNER_LABEL_DATA_AUTO_REFRESHED')}
              </GridLayout.Col>
              <GridLayout.Col cols={GRID_SIZE_CONTROL}>
                <Input
                  type="checkbox"
                  onChange={notifyChange(this.onChangeAutoRefreshed, EventsUtils.CHECKBOX)}
                  checked={this.state.enable}
                />
              </GridLayout.Col>
            </GridLayout.Row>

            <GridLayout.Row className="form-group">
              <GridLayout.Col cols={GRID_SIZE_LABEL}>
                {localizer.getText('REPORTDESIGNER_LABEL_UPDATE_INTERVAL')}
              </GridLayout.Col>
              <GridLayout.Col cols={GRID_SIZE_CONTROL}>
                <div className="form-text">
                  <ValidatorInput
                    className="form-control input-text"
                    onChange={notifyChange(this.onChangeUpdateInterval, EventsUtils.INPUT)}
                    value={updateIntervalValue}
                    validations={intervalConstraint}
                    field="interval"
                  />
                </div>
                <div className="interval">(s)</div>
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
        </div>
      );
    }
  });

  module.exports = DataRefreshSetting;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/Izenda.DataRefreshSetting.jsx